import { getElementChild, getElements } from '../Utility/Dom'

class IntroReveal {
  private readonly container: HTMLElement
  private readonly content: HTMLElement | null
  private expanded = false
  private maxHeight: number = 100
  private readonly toggle: HTMLElement | null

  constructor(container: HTMLElement) {
    this.container = container
    this.content = getElementChild(container, 'intro-reveal-content')
    this.toggle = getElementChild(container, 'intro-reveal-toggle')
  }

  public init(): void {
    if (this.content === null || this.toggle === null) {
      return
    }

    if (this.content.scrollHeight > this.maxHeight) {
      this.container.classList.add('intro-reveal--clamped')
      this.addEvents()
    }
  }

  private addEvents(): void {
    this.toggle?.addEventListener('click', (): void => {
      this.expanded = !this.expanded

      if (this.expanded) {
        this.container.classList.remove('intro-reveal--clamped')
        this.container.classList.add('intro-reveal--expanded')
        this.toggle!.setAttribute('aria-expanded', 'true')
        this.toggle!.textContent = this.toggle!.dataset.labelLess ?? ''
      } else {
        this.container.classList.remove('intro-reveal--expanded')
        this.container.classList.add('intro-reveal--clamped')
        this.toggle!.setAttribute('aria-expanded', 'false')
        this.toggle!.textContent = this.toggle!.dataset.labelMore ?? ''
      }
    })
  }
}

const containers = getElements('intro-reveal')

containers.forEach((container: HTMLElement): void => {
  const introReveal = new IntroReveal(container)
  introReveal.init()
})
